exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-079ecb12] {\n  max-width: 500px;\n}\n.modal-body[data-v-079ecb12] {\n  max-height: 70vh;\n  overflow: auto;\n}\n.modal-body span[data-v-079ecb12] {\n    font-weight: 500;\n    min-width: 145px;\n    display: inline-block;\n}\n.modal-body > div[data-v-079ecb12] {\n    margin-bottom: 10px;\n}\n.modal-body > div > div[data-v-079ecb12] {\n      display: inline-block;\n}\n", ""]);

// exports
